import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ScanResultCard } from './ScanResultCard';
interface ScanResultModalProps {
  isOpen: boolean;
  status: 'completed' | 'failed';
  score?: number;
  riskLevel?: string;
  errorMessage?: string;
  onViewResults?: () => void;
  onRetry?: () => void;
  onClose: () => void;
}
export function ScanResultModal({
  isOpen,
  status,
  score = 0,
  riskLevel = 'low',
  errorMessage,
  onViewResults,
  onRetry,
  onClose
}: ScanResultModalProps) {
  if (!isOpen) return null;
  return <AnimatePresence data-id="element-1810" data-mp="1ojzbyi8xb3a9">
      {isOpen && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" data-id="element-1811" data-mp="1aiwnjyughgw6">
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.3,
        ease: 'easeOut'
      }} className="w-full max-w-md" data-id="element-1812" data-mp="1fh7y6bskrvfg">
            <ScanResultCard score={score} status={status} errorMessage={errorMessage} onViewReport={onViewResults} onBack={onClose} onRetry={onRetry} data-id="element-1813" data-mp="zqjc3czq8yar" />
          </motion.div>
        </div>}
    </AnimatePresence>;
}